import * as guards from './http-guards'

const http = {
  guards,
}

export default http
